import { React } from "react";
import LoginMaskIcon from "../assets/icons/login_mask.svg";
import MaskVideo from "../assets/videos/mask_background.mp4";

const Mask = (props) => {
  const { className, width, height, style, id, maskHeight, maskWidth } = props;
  return (
    <div className={`text-white position-relative ${className}`} style={style}>
      <video
        autoPlay
        muted
        loop
        id={id}
        width={width}
        height={height}
        className="position-absolute"
      >
        <source src={MaskVideo} type="video/mp4" />
        Your browser does not support HTML5 video.
      </video>
      <div className={`text-white position-absolute left-0 top-0`}>
        <img
          src={LoginMaskIcon}
          alt="mask"
          width={maskWidth}
          height={maskHeight}
        />
      </div>
    </div>
  );
};

export default Mask;
